export type RbacPolicyProps = Array<RbacPolicy> | RbacPolicy | undefined;

// This should be kept in sync with Commercial.Billing.Admin.Api/Authorization/Roles.cs
export const RbacPolicies = {
  Admin: {
    All: "Admin.All",
    Read: "Admin.Read",
    ReadWrite: "Admin.ReadWrite",
  },
  ServerLicenses: {
    Read: "ServerLicenses.Read",
    ReadWrite: "ServerLicenses.ReadWrite",
    CloudXmlRead: "ServerLicenses.CloudXmlRead",
  },
  CloudSubscriptions: {
    Read: "CloudSubscriptions.Read",
    ReadWrite: "CloudSubscriptions.ReadWrite",
    Cancel: "CloudSubscriptions.Cancel",
    InfrastructureRenew: "CloudSubscriptions.InfrastructureRenew",
    InfrastructureReadWrite: "CloudSubscriptions.InfrastructureReadWrite",
  },
  CloudSubscriptionIntents: {
    Read: "CloudSubscriptionIntents.Read",
    ReadWrite: "CloudSubscriptionIntents.ReadWrite",
  },
  Trials: {
    Read: "Trials.Read",
    ReadWrite: "Trials.ReadWrite",
  },
  Users: {
    Read: "Users.Read",
    ReadWrite: "Users.ReadWrite",
  },
  Prices: {
    Read: "Prices.Read",
  },
  SubscriptionGroups: {
    Read: "SubscriptionGroups.Read",
    ReadWrite: "SubscriptionGroups.ReadWrite",
  },
  Subscriptions: {
    Read: "Subscriptions.Read",
    ReadWrite: "Subscriptions.ReadWrite",
  },
  RateCards: {
    Read: "RateCards.Read",
    ReadWrite: "RateCards.ReadWrite",
  },
  BillingAccounts: {
    Read: "BillingAccounts.Read",
    ReadWrite: "BillingAccounts.ReadWrite",
  },
  Orders: {
    Read: "Orders.Read",
    ReadWrite: "Orders.ReadWrite",
  },
  Fulfillments: {
    Read: "Fulfillments.Read",
    ReadWrite: "Fulfillments.ReadWrite",
  },
} as const;

type AdminRbacPolicies = (typeof RbacPolicies.Admin)[keyof typeof RbacPolicies.Admin];
type ServerLicensesRbacPolicies = (typeof RbacPolicies.ServerLicenses)[keyof typeof RbacPolicies.ServerLicenses];
type CloudSubscriptionsRbacPolicies =
  (typeof RbacPolicies.CloudSubscriptions)[keyof typeof RbacPolicies.CloudSubscriptions];
type CloudSubscriptionIntentsRbacPolicies =
  (typeof RbacPolicies.CloudSubscriptionIntents)[keyof typeof RbacPolicies.CloudSubscriptionIntents];
type SubscriptionGroupsRbacPolicies =
  (typeof RbacPolicies.SubscriptionGroups)[keyof typeof RbacPolicies.SubscriptionGroups];
type SubscriptionsRbacPolicies = (typeof RbacPolicies.Subscriptions)[keyof typeof RbacPolicies.Subscriptions];
type RateCardsRbacPolicies = (typeof RbacPolicies.RateCards)[keyof typeof RbacPolicies.RateCards];
type BillingAccountsRbacPolicies = (typeof RbacPolicies.BillingAccounts)[keyof typeof RbacPolicies.BillingAccounts];
type OrdersRbacPolicies = (typeof RbacPolicies.Orders)[keyof typeof RbacPolicies.Orders];
type FulfillmentsRbacPolicies = (typeof RbacPolicies.Fulfillments)[keyof typeof RbacPolicies.Fulfillments];
type UsersRbacPolicies = (typeof RbacPolicies.Users)[keyof typeof RbacPolicies.Users];
type TrialsRbacPolicies = (typeof RbacPolicies.Trials)[keyof typeof RbacPolicies.Trials];
type PricesRbacPolicies = (typeof RbacPolicies.Prices)[keyof typeof RbacPolicies.Prices];

export type RbacPolicy =
  | AdminRbacPolicies
  | ServerLicensesRbacPolicies
  | CloudSubscriptionsRbacPolicies
  | CloudSubscriptionIntentsRbacPolicies
  | SubscriptionGroupsRbacPolicies
  | SubscriptionsRbacPolicies
  | RateCardsRbacPolicies
  | BillingAccountsRbacPolicies
  | OrdersRbacPolicies
  | FulfillmentsRbacPolicies
  | UsersRbacPolicies
  | TrialsRbacPolicies
  | PricesRbacPolicies;
